import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Tooltip, makeStyles } from '@material-ui/core'
import BasicTable from '../../../../atoms/BasicTable'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import Markup from '../../../../atoms/Markup'
import Icon from '../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  descriptionWrap: {
    '&.MuiTooltip-popper': {
      '& .MuiTooltip-tooltipPlacementTop': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: 'var(--shadow-sm)',
        fontSize: 'var(--font-size-sm)',
        padding: 'var(--padding-sm) var(--padding-md)'
      },
      '& .MuiTooltip-tooltipPlacementBottom': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: 'var(--shadow-sm)',
        fontSize: 'var(--font-size-sm)',
        padding: 'var(--padding-sm) var(--padding-md)'
      }
    }
  }
}))

function DatapointsTable ({ datapoints, onAccessorClick }) {
  const classes = useStyles()
  const { formatter } = useFormattingContext()
  const tooltipTitle = useCallback((description) => {
    return (
      <Markup type='markdown' value={description} />
    )
  }, [])

  return (
    <BasicTable className='opal-presentation-table zebra-rows primary'>
      <thead className='opt-thead'>
        <tr className='opt-tr'>
          <th className='opt-th'>Accessor</th>
          <th className='opt-th'>Name</th>
          <th className='opt-th'>Type Class</th>
          <th className='opt-th'>Type</th>
          <th className='opt-th'>Enumeration</th>
          <th className='opt-th'>Ordinal</th>
          <th className='opt-th'>Nullable</th>
          <th className='opt-th'>Len</th>
          <th className='opt-th'>Scale</th>
          <th className='opt-th'>Precision</th>
          <th className='opt-th'>PII</th>
          <th className='opt-th'>AI</th>
          <th className='opt-th'>Deprecated</th>
          <th className='opt-th'>Hidden</th>
        </tr>
      </thead>
      <tbody className='opt-tbody'>
        {(datapoints || []).map((dp) => (
          <tr className='opt-tr' key={`dp_${dp.catalogDatapointId}`}>
            <td className='opt-td'>
              <div className='clickable selectable' onClick={() => onAccessorClick?.(dp)}>
                {dp.description ? (
                  <Tooltip
                    title={tooltipTitle(dp.description)}
                    classes={{
                      tooltip: 'big_tooltip',
                      popper: classes.descriptionWrap
                    }}
                  >
                    <div className='flex flex-row gap-sm items-center'>
                      <span>{dp.accessor}</span>
                      <Icon name='info' customSize={16} />
                    </div>
                  </Tooltip>
                ) : (
                  <span>{dp.accessor}</span>
                )}
              </div>
            </td>
            <td className='opt-td'>{dp.displayName}</td>
            <td className='opt-td'>{dp.typeClass}</td>
            <td className='opt-td'>{dp.type}</td>
            <td className='opt-td'>{formatter(!!dp.enumerationId, 'bool')}</td>
            <td className='opt-td'>{dp.ordinal}</td>
            <td className='opt-td'>{formatter(!!dp.nullable, 'bool')}</td>
            <td className='opt-td'>{formatter(dp.length, 'number')}</td>
            <td className='opt-td'>{formatter(dp.numericScale, 'number')}</td>
            <td className='opt-td'>{formatter(dp.precision, 'number')}</td>
            <td className='opt-td'>{formatter(!!dp.isPii, 'bool')}</td>
            <td className='opt-td'>{formatter(!!dp.isAiEnabled, 'bool')}</td>
            <td className='opt-td'>{formatter(!!dp.isDeprecated, 'bool')}</td>
            <td className='opt-td'>{formatter(!!dp.isHidden, 'bool')}</td>
          </tr>
        ))}
      </tbody>
    </BasicTable>
  )
}

DatapointsTable.propTypes = {
  datapoints: PropTypes.arrayOf(PropTypes.shape({
    catalogDatapointId: PropTypes.number,
    accessor: PropTypes.string,
    displayName: PropTypes.string,
    type: PropTypes.string,
    typeClass: PropTypes.string,
    enumerationId: PropTypes.number,
    ordinal: PropTypes.number,
    nullable: PropTypes.bool,
    length: PropTypes.number,
    numericScale: PropTypes.number,
    numericPrecision: PropTypes.number,
    description: PropTypes.string,
    isPii: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    isAiEnabled: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    isDeprecated: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    isHidden: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
  })),
  onAccessorClick: PropTypes.func
}

export default DatapointsTable
